import { render, staticRenderFns } from "./LotModal.vue?vue&type=template&id=6871e6af"
import script from "./LotModal.vue?vue&type=script&lang=js"
export * from "./LotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports